import { Component, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { MobileFilterDialog } from './components/mobile-filter-dialog'

@Component({
  selector: 'dhp-filter-group',
  templateUrl: './filter-group.html',
  imports: [FormsModule, MobileFilterDialog],
})
export class FilterGroup {
  public readonly articleAmount = input.required<number>()

  protected readonly resetFilters = output()
}
